import React from "react";

import "./spinLoader.css";

export default function SpinLoader() {
    return <span className="spin-loader"/>;
}